import { render, staticRenderFns } from "./EditInstructions.vue?vue&type=template&id=f05963de&scoped=true&"
import script from "./EditInstructions.vue?vue&type=script&lang=js&"
export * from "./EditInstructions.vue?vue&type=script&lang=js&"
import style0 from "./EditInstructions.vue?vue&type=style&index=0&id=f05963de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05963de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VTextarea})
